import React, { Component } from 'react';
import BreadcrumbWithoutAjax from "../common/BreadcrumbWithoutAjax";
import Nav from "../common/Nav";
import Ichat from "../common/chat/Ichat";
import Global from "../../Global";
import Footer from "../common/footer/Footer";
import ECareLinkService from "../plan/eCareLinkService";
import PromoSlider from "../common/widgets/PromoSlider";
import LookingPlan from "../plan/LookingPlan";
import SimPlanPromo from "../plan/SimPlanPromo";
import DataPack from '../plan/DataPack';
import ValueServices from '../plan/ValueServices';
import Navigation from "../common/Navigation/Navigation";
import SimPlanFilter from "../plan/SimPlanFilter";
import Subtitle from "../plan/Subtitle";

/*
 * TODO: Full Migration of SimPlanPromo
 * TODO: Full Migration of LookingPlan
 */
export default class PlanList extends Component{
    constructor(props){
        super(props);

        let ichatLang = window.THREE_REACT_APP_GLOBAL.language;
        if (ichatLang.toLowerCase() === 'tc'.toLowerCase()) {
            ichatLang = 'chi';
        }
        this.iChatUrl = 'https://3ichat.three.com.hk/michat/Client/Dashboard/login?bu=MOBILE&lang=' + ichatLang;

        this.state = {
            //Breadcrumb
            categoryData: [],
            //SimPlanPromo
            apiData: {
                generalData: {},
                simPlanData: [],
                serviceBox: []
            },
            //Currently, LookingPlan uses plans-advisor
            //Therefore no state data for LookingPlan
            //E-Care
            eCareServiceBox: [],
            eCareGeneralData: {},
            //Default Plan Fallback
            defaultNavPlanId: "",
            defaultNavPlanType: ""
        }

        this.changeState = this.props.changeState;
    }

    componentDidMount = async() => {
        try {
            let response = await fetch(Global.getAPI("plan-list"));
            if (response.status >= 400) throw new Error("Error API: plan");
            let responseJson = await response.json();

            let defaultPlan = responseJson.simPlan.items[0].boxDataPlanLabel[0];

            this.setState({
                //Breadcrumb
                categoryData: responseJson.general.category,
                //SimPlan
                apiData: {
                    generalData: responseJson.general,
                    simPlanData: responseJson.simPlan.items,
                    serviceBox: responseJson.serviceBox.items
                },
                //E-Care
                eCareServiceBox: responseJson.serviceBox.items,
                eCareGeneralData: responseJson.general,
                //Default Fallback
                defaultNavPlanId: defaultPlan.planId,
                defaultNavPlanType: defaultPlan.planType
            })
        }
        catch(e){
            console.error(e);
        }
    }

    //Handler for SimPlanPromo
    selectPlan = (plantype, planid) => {
        //console.log("Plan Type: " + plantype);
        //console.log("Plan ID: " + planid);
        this.changeState(planid, plantype);
        // this.setState({
        //     selectedDataLabel: dataPlan.dataLabel,
        //     changePage: true
        // })
    };

    //Handler for Looking Plan
    //For View All Plan
    //TODO: Maybe adding listeners to some variables?
    changeCurrentPage = () => {
        this.changeState(this.state.defaultNavPlanId, this.state.defaultNavPlanType);
        // this.setState({
        //     changePage: true
        // })
    };

    render(){
        return(
            <div className="react-row">
                {/*<Nav />*/}
                <Navigation/>
                <main>
                    <Subtitle urlAPI={'subtitle.plans'}/>
                    <PromoSlider urlAPI='promoslider.plans'/>
                    <BreadcrumbWithoutAjax categoryData={this.state.categoryData}/>
                    {/*<div onClick={() => this.changeState(1, "type1")}>Type 1</div>*/}
                    {/*<div onClick={() => this.changeState(2, "type2")}>Type 2</div>*/}
                    {/*<div onClick={() => this.changeState(3, "type3")}>Type 3</div>*/}
                    {/*<div onClick={() => this.changeState(4, "type4")}>Type 4</div>*/}
                    <SimPlanPromo
                        generalData={this.state.apiData.generalData}
                        simPlanData={this.state.apiData.simPlanData}
                        serviceBox={this.state.apiData.serviceBox}
                        onSelect={this.selectPlan}
                    />
                    {/*<LookingPlan change={this.changeCurrentPage}*/}
                    {/*             toPlanDetail={(plantype, planid) => this.selectPlan(plantype, planid)}*/}
                    {/*/>*/}
                    {/*<DataPack/>*/}
                    {/*<ValueServices/>*/}
                    {/*<ECareLinkService serviceBox={this.state.eCareServiceBox} general={this.state.eCareGeneralData}/>*/}
                </main>
                <Footer />
                {/*<Ichat item={{}} iChatUrl={this.iChatUrl}/>*/}
            </div>
        )
    }
}